import {deserialize, deserializeAs, inheritSerialization} from 'cerialize';
import {Entity} from './entity';
import {ContactCMI} from './contactCMI';
import {Adresse} from './adresse';
import {Artisan} from './artisan';
import {Partner} from "./partner";
import {Logo} from "./Logo";

@inheritSerialization(Entity)
export class Societe extends Entity {

  @deserialize
  email: string;

  @deserializeAs(Societe, 'societe_mere')
  societeMere: Societe = null;

  @deserializeAs(Societe, 'societe_facturation')
  societeFacturation: Societe = null;

  @deserializeAs('raison_sociale')
  raisonSociale: string;

  @deserializeAs(Logo, 'logo')
  logo: Logo = null;

  @deserialize
  siret: string;

  @deserializeAs('numero_tva')
  numeroTva: string;

  @deserialize
  kbis: string;

  @deserialize
  type: string;

  @deserializeAs(Adresse, 'adresse')
  adresse;

  @deserializeAs(Partner, 'partner')
  partner: Partner = null;

}
